import React from "react";
import { Route, Switch } from "react-router-dom";
import PropTypes from "prop-types";
// async components
// import Dashboard from "./Dashboard";
import {
  AsyncSessionPage404Component,
  AsyncDashboardComponent
} from "Components/AsyncComponent/AsyncComponent";

const receipt = ({ match }) => (
  <div className="content-wrapper">
    <Switch>
      <Route
        exact={true}
        path={`${match.url}`}
        component={AsyncDashboardComponent}
      />
      <Route component={AsyncSessionPage404Component} />
    </Switch>
  </div>
);
receipt.propTypes = {
  match: PropTypes.object
};

export default receipt;
